import type { Tones } from './registry';

/**
 * The master's palette (docs/art/character-ref/hero-turnaround.png, the master style reference):
 * warm white, maroon, red, gold, ink black and dark brown, each in the two or three tones of its
 * cel shading. Every plate's frame, fittings and tassels are drawn in these; only the themed
 * ornaments bring their own colours.
 */
export const M = {
  white: '#efe9e6',
  whiteHi: '#fbf7f2',
  whiteLo: '#d2c4bc',
  whiteDeep: '#a8968c',
  maroon: '#6e1f2a',
  maroonHi: '#8e3440',
  maroonLo: '#4a121c',
  red: '#c0242c',
  redHi: '#e2504a',
  redLo: '#841820',
  gold: '#c99a4a',
  goldHi: '#efcd8a',
  goldLo: '#8e6226',
  goldDeep: '#5a3a16',
  ink: '#1e1618',
  inkHi: '#3a2c2e',
  brown: '#3a2420',
  brownHi: '#5a3a2e',
} as const;

export const GOLD: Tones = [M.goldHi, M.gold, M.goldLo];
export const RED: Tones = [M.redHi, M.red, M.redLo];
export const MAROON: Tones = [M.maroonHi, M.maroon, M.maroonLo];
export const WHITE: Tones = [M.whiteHi, M.white, M.whiteLo];
export const INK: Tones = [M.inkHi, M.ink, '#120c0e'];

/** Warm white paper, the robe's cloth: the paper plates' field. */
export const PAPER: Tones = ['#f7f1ea', '#ebe2d8', '#d2c4b8'];
